import React, { ReactNode } from 'react';
import { useErrorHandler } from '../utils/errorHandler';

interface ErrorHandlerProviderProps {
  children: ReactNode;
}

const ErrorHandlerProvider: React.FC<ErrorHandlerProviderProps> = ({
  children,
}) => {
  // Initialize the error handler
  useErrorHandler();

  return <>{children}</>;
};

export default ErrorHandlerProvider;
